/**
 * Converts filter_groups (snake_case) to filterGroups (camelCase)
 * for Magento API compatibility. Removes the snake_case key after copying.
 */
export function normalizeParams(params: any): any {
  if (!params?.searchCriteria) return params;

  const normalised = {
    ...params,
    searchCriteria: {
      ...params.searchCriteria,
      filterGroups: params.searchCriteria.filter_groups ?? params.searchCriteria.filterGroups ?? [],
    },
  };

  if (normalised.searchCriteria.filter_groups) {
    delete normalised.searchCriteria.filter_groups;
  }

  return normalised;
}

/**
 * Builds a Magento searchCriteria object from a declarative config.
 */
export function buildSearchCriteria(config: {
  filters?: Array<
    Array<{
      field: string;
      value: string | number;
      condition_type?: string;
    }>
  >;
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: 'ASC' | 'DESC';
}): { searchCriteria: any } {
  const searchCriteria: any = {};

  if (config.filters) {
    searchCriteria.filterGroups = config.filters.map((group) => ({
      filters: group.map((f) => ({
        field: f.field,
        value: f.value,
        condition_type: f.condition_type || 'eq',
      })),
    }));
  }

  if (config.page != null) searchCriteria.currentPage = config.page;
  if (config.pageSize != null) searchCriteria.pageSize = config.pageSize;

  if (config.sortField) {
    searchCriteria.sortOrders = [
      {
        field: config.sortField,
        direction: config.sortDirection || 'ASC',
      },
    ];
  }

  return { searchCriteria };
}
